import $ from "jquery";
import __ajax from "./__ajax";

const submitForm = () => {
  const init = () => {
    execute();
  };

  const execute = () => {
    const el = {
      form: ".js-form-autosubmit",
      view: ".js-toggle-view-form",
    };

    if ($(el.form).length === 0) return;

    $(document).on("submit", el.form, function (e) {
      e.preventDefault();
      const listData = Object.fromEntries(new FormData($(this)[0]).entries());

      __ajax($(this), listData).then(() => {
        $(el.view).each(function () {
          if ($(this).data("show_if") === "success") {
            $(this).show();
          } else {
            $(this).hide();
          }
        });
      });
    });
  };

  init();
};

try {
  submitForm();
} catch (error) {
  console.error("submitForm", error);
}
